module.exports = __webpack_public_path__ + "img/tv-mobile.2e55e6c0.jpg";